import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import Benefits from './components/Benefits';
import Safety from './components/Safety';
import HowToBuy from './components/HowToBuy';
import FAQ from './components/FAQ';
import SEOArticles from './components/SEOArticles';
import CTAArticle from './components/CTAArticle';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <Benefits />
      <Safety />
      <HowToBuy />
      <SEOArticles />
      <FAQ />
      <CTAArticle />
      <Footer />
    </main>
  );
}